import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'highlight',
    standalone: true
})
export class HighlightPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(value: string, searchTerm: string): SafeHtml {
        if (!searchTerm || !value) {
            return value;
        }

        const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');
        const highlighted = value.replace(regex, '<mark class="search-result-highlight">$1</mark>');

        return this.sanitizer.bypassSecurityTrustHtml(highlighted);
    }

    private escapeRegExp(value: string): string {
        return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
}
